// Host-based routing. Unknown hosts (preview) use ?site=<domain>, remembered per tab.
export const SITES = {
  "333sos.com": "teaser",
  "333sos.net": "redirect",
  "010230.com": "log",
  "radio333.com": "radio",
  "333secret.com": "cipher",
  "333sos.ai": "denied",
  "333helpers.com": "helpers",
  "333notes.com": "denied",
  "333logs.com": "denied",
  "333maps.com": "denied",
  "333list.com": "denied",
};

export function currentHost() {
  return window.location.hostname.replace(/^www\./, "").toLowerCase();
}

export function isDevHost() {
  return !(currentHost() in SITES);
}

// Link to another game site; preview hosts stay on the same origin with ?site=.
export function siteUrl(domain, params = {}) {
  const q = new URLSearchParams(params);
  if (isDevHost()) return `${window.location.origin}${window.location.pathname}?site=${domain}${q.toString() ? `&${q}` : ""}`;
  return `https://${domain}/${q.toString() ? `?${q}` : ""}`;
}

export function currentSite() {
  const host = currentHost();
  if (SITES[host]) return { domain: host, kind: SITES[host] };
  const param = new URLSearchParams(window.location.search).get("site");
  if (param && SITES[param]) sessionStorage.setItem("dev_site", param);
  if (param === "index") sessionStorage.removeItem("dev_site");
  const d = sessionStorage.getItem("dev_site");
  return d ? { domain: d, kind: SITES[d], dev: true } : { domain: null, kind: "index", dev: true };
}
